<div class="position-consult-page">

  <div class="page-intro">
    <b3-breadcrumbs aria-label="Breadcrumb">
      <b3-breadcrumbs-item variant="icon" href="/"></b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Operações de crédito</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Consultas</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Posição de Créditos</b3-breadcrumbs-item>
    </b3-breadcrumbs>
    <h1 class="page-title">Consulta de Posição</h1>
  </div>

  <section class="consult-content" aria-label="Consulta de posição de créditos de carbono">
    <div class="consult-toolbar">
      <p class="consult-toolbar__summary" aria-live="polite">{{ positionsFoundLabel }}</p>
      <div class="consult-toolbar__actions">
        <b3-button
          type="button"
          variant="outlined"
          tone="default"
          size="lg"
          class="consult-toolbar__filter-btn"
          [attr.aria-label]="filterButtonAriaLabel"
          (b3-click)="openAdvancedFilter()">
          <b3-icon name="filter_alt"></b3-icon>
          <span *ngIf="filtersTotal > 0" class="consult-toolbar__filter-count">({{ filtersTotal }})</span>
          Filtrar
        </b3-button>
      </div>
    </div>

    <app-position-consult-list
      (positionDetail)="openDetail($event)"
      (valueFilterTotal)="onValueFilterTotal($event)"
      (valueTotal)="onValueTotal($event)"
      (loadFailed)="onListLoadFailed()">
    </app-position-consult-list>
  </section>

  <footer class="page-footer">
    <p class="page-footer__text">B3SA© 2026 Plataforma de Carbono. Todos os direitos reservados.</p>
  </footer>
</div>

<app-position-consult-filter
  [isOpen]="showFilter"
  (closed)="onFilterDrawerClosed()">
</app-position-consult-filter>

<app-position-consult-details-drawer
  [isOpen]="showDetailsDrawer"
  [position]="selectedPositionForDetails"
  (closed)="onDetailsDrawerClosed()">
</app-position-consult-details-drawer>

<app-position-consult-error-modal
  [open]="isErrorModalOpen"
  [message]="errorModalMessage"
  (closed)="onErrorModalClosed()">
</app-position-consult-error-modal>

<b3-toast-region class="position-consult-toast-region">
  <b3-toast
    *ngIf="showFilterUpdateNotice"
    [open]="true"
    variant="info"
    label="Consulta atualizada para os filtros aplicados"
    auto-dismiss
    aria-live="polite"
    (b3-close)="onFilterNoticeDismiss()">
    <b3-button
      slot="action"
      variant="ghost"
      tone="default"
      (b3-click)="onFilterNoticeUndo()">
      Desfazer
    </b3-button>
    <b3-button
      slot="close"
      variant="ghost"
      tone="default"
      aria-label="Fechar aviso de filtros"
      (b3-click)="onFilterNoticeDismiss()">
      <b3-icon name="clear" size="sm" tone="default"></b3-icon>
    </b3-button>
  </b3-toast>

  <b3-toast
    *ngIf="showLoadErrorBanner"
    [open]="true"
    variant="danger"
    label="Não foi possível carregar a consulta."
    auto-dismiss
    (b3-close)="onLoadErrorDismiss()">
    <b3-button
      slot="action"
      variant="ghost"
      tone="default"
      (b3-click)="onLoadErrorRetry()">
      Tentar novamente
    </b3-button>
    <b3-button
      aria-label="Fechar notificação"
      (b3-click)="onLoadErrorDismiss()">
      <b3-icon name="close"></b3-icon>
    </b3-button>
  </b3-toast>
</b3-toast-region>
